import {useCallback} from 'react';
import {OptionsDropdown} from '~/components';
import {DATA_TEST_IDS} from '~/lib/const';

export function ProductOptionsDropdown({
  values,
  availableValues,
  name,
  error,
  activeValue,
  handleChange,
}: {
  values: string[];
  availableValues: string[];
  name: string;
  activeValue: string | null;
  error?: boolean;
  handleChange: (name: string, value: string) => void;
}) {
  const updateSelectedOption = useCallback(
    (name: string, value: string) => {
      handleChange(name, value);
    },
    [handleChange],
  );

  return (
    <div
      data-testid={DATA_TEST_IDS.PRODUCT_OPTIONS_DROPDOWN}
      className="relative w-full"
    >
      <OptionsDropdown
        name={name}
        selectedValue={activeValue ?? undefined}
        values={values}
        availableValues={availableValues}
        onChange={updateSelectedOption}
        error={error}
      />
      {error && (
        <div
          data-testid={DATA_TEST_IDS.ERROR}
          className="text-red-500 text-xs mt-1 absolute"
        >
          This is a required field.
        </div>
      )}
    </div>
  );
}
